module.exports = __webpack_public_path__ + "static/media/bfile-watercraft.3d55ea80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-watercraft.svg
// module id = 207
// module chunks = 0